import { SORT_DIRECTION } from 'utils/appConstants';


export const getDirection = (dir) => ({
  [SORT_DIRECTION.ASCENDING]: 'asc',
  [SORT_DIRECTION.DESCENDING]: 'desc',
}[dir] || 'asc');
